import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Navigate, useLocation } from "react-router-dom";
import {
	canAccessRouteWithSnapshot,
	loadRouteAccessSnapshot,
} from "../services/routeAccess";

export const RouteAccessGuard = ({ children, routePath = "" }) => {
	const location = useLocation();
	const [loading, setLoading] = useState(true);
	const [allowed, setAllowed] = useState(false);

	useEffect(() => {
		let active = true;

		const comprobarAcceso = async () => {
			setLoading(true);

			try {
				const snapshot = await loadRouteAccessSnapshot();
				const pathToCheck = routePath || location.pathname;

				if (!active) {
					return;
				}

				setAllowed(canAccessRouteWithSnapshot(pathToCheck, snapshot));
			} catch (error) {
				console.error("Error cargando permisos de ruta:", error);

				if (!active) {
					return;
				}

				setAllowed(true);
			} finally {
				if (active) {
					setLoading(false);
				}
			}
		};

		comprobarAcceso();

		return () => {
			active = false;
		};
	}, [location.pathname, routePath]);

	if (loading) {
		return (
			<div style={{ display: "flex", justifyContent: "center", marginTop: 40 }}>
				<CircularProgress />
			</div>
		);
	}

	if (!allowed) {
		return (
			<Navigate
				to="/"
				replace
				state={{ accessDeniedPath: location.pathname }}
			/>
		);
	}

	return children;
};

